// extracted by mini-css-extract-plugin
module.exports = {"bp320":"320px","bp375":"375px","bp425":"425px","bp768":"768px","bp1024":"1024px","bp1440":"1440px","bp1680":"1680px","bp2560":"2560px"};